import { NerdWalletBadge } from '@ria-client/tw-shared-ui';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContentDocument } from '../types';
import { Slideshow } from './lib/slideshow';

export function FirstPersonPerspective({
  props,
}: NodeProps<{
  children: StructuredContentDocument[];
  question: string;
}>): React.JSX.Element {
  const { children, question } = props;

  return (
    <>
      <div className="mb-1">
        <div className="flex items-center gap-x-2 pb-2">
          <NerdWalletBadge size={27} />
          <span className="typography-body-small font-bold uppercase tracking-[.11rem]">
            More Nerdy Perspective{children.length > 1 ? 's' : ''}
          </span>
        </div>
        {/* 20px/1.5: packages/ui/src/Theme/index.ts:878, no matching composite. */}
        {question && <p className="font-sans text-xl leading-[1.5]">{question}</p>}
      </div>
      <Slideshow>
        {children.map((item, index) => (
          <StructuredContentRenderer doc={item} key={index} />
        ))}
      </Slideshow>
    </>
  );
}
